import React from 'react'

function GenerateReports() {
    return (
        <div className="max-w-6xl mx-auto bg-[#f3f4f6] ">
            <div className="flex items-center justify-center min-h-screen">
                <div className="max-w-sm w-full sm:w-1/2 lg:w-1/3 py-6 px-3">
                    <div className="bg-white shadow-xl rounded-lg overflow-hidden">
                        <div className="p-4">
                            <p className="text-[3rem] text-center text-gray-900">Generar Reportes</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GenerateReports